module.exports = __webpack_public_path__ + "img/rank-1-bg.bf6ad7fc.png";